import { render } from "./LiveIframe.vue?vue&type=template&id=b2335bdc"
import script from "./LiveIframe.vue?vue&type=script&lang=js"
export * from "./LiveIframe.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__